<template>
  <div class="tap-bar">
    <div class="tap-bar-buttons">
      <div class="tooltip-wrapper">
        <button 
          class="tab-button" 
          :class="{ active: currentView === 'MainScreen' }"
          @click="$emit('change-view', 'MainScreen')"
        >
          <img src="@/assets/ikonko.png" alt="Home" class="tab-icon" />
        </button>
      </div>
      
      <div class="tooltip-wrapper">
        <button 
          class="tab-button" 
          :class="{ active: currentView === 'ReferralsView' }"
          @click="$emit('change-view', 'ReferralsView')"
        >
          <img src="@/assets/ref.png" alt="Referrals" class="tab-icon" />
        </button>
      </div>
      
      <div class="tooltip-wrapper">
        <button 
          class="tab-button" 
          :class="{ active: currentView === 'TasksView' }"
          @click="$emit('change-view', 'TasksView')"
        >
          <img src="@/assets/task.png" alt="Tasks" class="tab-icon" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TapBar',
  props: {
    currentView: {
      type: String,
      required: true
    }
  },
  emits: ['change-view']
};
</script>

<style scoped>
.tap-bar {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 280px; /* Reduced width for 3 buttons */
  height: 70px;
  z-index: 1000;
  background: transparent; /* Fully transparent background */
}

.tap-bar-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 0; /* Remove gap between buttons */
}

.tooltip-wrapper {
  position: relative;
  flex: 1;
  height: 100%;
}

.tab-button {
  width: 100%;
  height: 70px;
  background: #1a1a1a;
  border: none;
  font-size: 28px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  margin: 0;
  box-shadow: none; /* Remove shadow */
  border-radius: 0;
  z-index: 1;
}

.tab-icon {
  width: 76px;
  height: 76px;
  object-fit: contain;
  filter: grayscale(100%) brightness(0.7);
  transition: all 0.3s ease;
}

.tab-button.active .tab-icon {
  filter: grayscale(0%) brightness(1) hue-rotate(90deg); /* Зеленый цвет при активации */
}

.tab-button:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.tab-button:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.tab-button.active {
  color: #4CAF50;
  transform: scale(1);
  box-shadow: none;
  background: #2a2a2a;
  z-index: 1;
}

.tab-button.active .tab-icon {
  filter: grayscale(0%) brightness(1) hue-rotate(90deg); /* Зеленый цвет при активации */
}

.tab-button:hover:not(.active) {
  color: #aaa;
  background: #222;
}
</style>